<template>
  <!-- banner图片编辑 -->
  <div>
    <a-modal
      :title="modalTitle"
      :visible="visible"
      :footer="null"
      @ok="closeFun"
      @cancel="closeFun"
      v-bind="this.$store.state.modalConfig"
    >
      <x-addEdit
        ref="addEdit"
        :itemLayout="$store.state.modal_ItemLayout"
        :formList="formList"
        :formKey="formKey"
        :addParam="addParam"
        :editParam="editParam"
        :detailParam="detailParam"
      >
        <template slot="shop" slot-scope="{formItem}">
          <a-form-item
            :label="formItem.label">
            <template v-for="(tag) in shoptags">
              <a-tag closable :key="tag" @close="()=>shoptagsClose(tag)">{{tag}}</a-tag>
            </template>

            <a-button type="primary" @click="chooseShop">选择店铺</a-button>
            <a-input style="visibility:hidden;display:inline-block;width:20%" v-decorator="formItem.props" :rows="4" />
          </a-form-item>
        </template>

        <template slot="goods" slot-scope="{formItem}">
          <a-form-item
            :label="formItem.label">
            <template v-for="(tag) in producttags">
              <a-tag closable :key="tag" @close="()=>producttagsClose(tag)">{{tag}}</a-tag>
            </template>
            <a-button type="primary" @click="chooseProduct">选择商品</a-button>
            <a-input style="visibility:hidden;display:inline-block;width:20%" v-decorator="formItem.props" :rows="4" />
          </a-form-item>
        </template>

      </x-addEdit>
    </a-modal>

    <!--选择商品弹窗-->
    <a-modal
        title="选择商品"
        :visible="CMVisible"
        @cancel="CMVisible=false"
        @ok="CMConfirm"
        :confirmLoading="btnLoading.loading"
        v-bind="$store.state.modalConfig"
        width="1000px"
    >
      <product-list ref="productList" :showRecommendation = false></product-list>
    </a-modal>

    <!--选择店铺弹窗-->
    <a-modal
        title="选择店铺"
        :visible="CSVisible"
        @cancel="CSVisible=false"
        @ok="CSConfirm"
        :confirmLoading="btnLoading.loading"
        v-bind="$store.state.modalConfig"
        width="1000px"
    >
      <shop-list ref="shoplist"></shop-list>
    </a-modal>
  </div>
</template>

<script>
import { fetchSelect } from '@/utils/mixins';
import Moment from 'moment';
import productList from './productList.vue';
import shopList from '../merchantRecommend/shopList.vue';
export default {
  name: 'bannerAdd',
  mixins: [fetchSelect],
  components: {productList, shopList},
  data () {
    return {
      shoptags: [],
      producttags: [],
      CSVisible: false,
      CMVisible: false,
      btnLoading: {loading: false},
      newparam: {businessType: 1},
      modalTitle: '新增',
      visible: false,
      lngLat: [],
      position: '',
      inputKey: {
        lng: 'mapLng',
        lat: 'mapLat',
        address: 'address'
      },

      formList: [
        {
          label: 'BANNER图',
          inputType: 'upload',
          options: [],
          handle: '',
          fileList: [],
          placeholder: '',
          tip: 'tip',
          beforeHandle: this.beforeUpload,
          uploadParam: {
            url: '/local/upload',
            iconUrl: 'imageUrl',
            iconName: 'fileName',
            action: this.$store.state.uploadUrlJava,
            accept: this.$store.state.imgAccept,
            listType: 'picture',
            accept: '.jpg,.jpeg,.png,.gif',
            limit: 1,
            uploadType: 4 // // 上传的文件类型
          },
          props: ['image', {
            rules: [{ required: true, message: '请上传BANNER图' }]
          }]
        },
        {
          label: '广告位',
          inputType: 'select',
          options: [
            { value: 1, label: '本地生活首页' },
            { value: 2, label: '管家通首页' },
            { value: 3, label: '兴农严选' },
            { value: 4, label: '发县之旅（土特）' },
            { value: 5, label: '发县之旅（文旅）' }
          ],
          handle: this.bannerChange,
          placeholder: '请选择广告位',
          props: ['scopeType', {
            rules: [{ required: true, message: '请输入名称' }]
          }]
        },
        {
          label: '范围',
          inputType: 'cascader',
          options: [],
          placeholder: '请选择范围',
          handle: this.regionChange,
          displayRender: this.regionDisplayRender,
          expandTrigger: 'click',
          loadData: e => {
            this.newRegionSelect(1, 'formList', '1,2', e, this.newparam);
          },
          props: ['areas', {
            rules: [{ required: true, message: '请选择范围' }]
          }]
        },
        {
          label: '名称',
          inputType: 'input',
          options: [],
          handle: '',
          placeholder: '请输入名称',
          props: ['name', {
            rules: [{ required: true, message: '请输入名称' }]
          }]
        }, {
          label: '排序',
          inputType: 'input',
          options: [],
          handle: '',
          placeholder: '排序',
          props: ['sort', {
            rules: [{ required: true, message: '请输入排序序号' }, { max: 5, message: '最多5位数' }, { pattern: this.REG.nonnegativeInteger, message: this.MESSAGE.nonnegativeInteger }]
          }]
        }, {
          label: '开始时间',
          inputType: 'dateTimePick',
          options: [],
          handle: '',
          placeholder: '开始时间',
          props: ['beginTime', {
            rules: [{ required: true, message: '请选择开始时间' }]
          }]
        }, {
          label: '结束时间',
          inputType: 'dateTimePick',
          options: [],
          handle: '',
          placeholder: '结束时间',
          props: ['endTime', {
            rules: [{ required: true, message: '请选择结束时间' }]
          }]
        }, {
          label: '点击后续动作',
          inputType: 'select',
          options: [],
          handle: (row) => this.typeChange(row),
          placeholder: '请选择点击后续动作',
          props: ['type', {
            rules: [{ required: true, message: '请选择点击后续动作' }]
          }]
        },
        {
          slot: 'shop',
          label: '店铺',
          isShow: false,
          inputType: 'input',
          options: [],
          handle: '',
          props: ['shop', {
            rules: [{ required: true, message: '请选择店铺' }]
          }]
        },
        {
          slot: 'goods',
          label: '商品',
          isShow: false,
          inputType: 'input',
          options: [],
          handle: '',
          props: ['goods', {
            rules: [{ required: true, message: '请选择商品' }]
          }]
        }, {
          label: '链接地址',
          inputType: 'input',
          isShow: false,
          options: [],
          handle: '',
          placeholder: '仅支持文档管理及公众号文章链接',
          props: ['link', {
            rules: [{ required: true, message: '请输入链接地址' }, {type: 'url', message: '请输入正确的url格式'}]
          }]
        }
      ],
      formKey: {
        image: undefined,
        areas: undefined,
        name: undefined,
        sort: undefined,
        beginTime: undefined,
        endTime: undefined,
        link: undefined,
        type: undefined
      },
      addParam: {
        url: '/local/banner/add',
        reqHandle: this.addreqHandle, // addParam、editParaM都会执行 reqHandle方法
        resHandle: this.ResHandle
      },
      editParam: {
        url: '/local/banner/',
        pathParam: true,
        reqHandle: this.addreqHandle,
        resHandle: this.ResHandle
      },
      detailParam: {
        url: '/local/banner/',
        resHandle: this.detailResHandle // this.detailResHandle
      }
    };
  },
  created () {
    this.newRegionSelect(2, 'formList', '1,2', null, this.newparam);
  },
  methods: {
    bannerChange (val) {
      this.$refs.addEdit.form.setFieldsValue({areas: undefined});
      this.formList[2].disabled = false;
      this.$refs.addEdit.form.setFieldsValue({type: undefined});
      if (val == 1) {
        this.formList[7].options = [
          { value: 1, label: '打开店铺详情' },
          { value: 2, label: '打开商品详情' },
          { value: 3, label: '打开URL' },
          { value: 4, label: '无后续动作' }
        ];
      } else if (val == 2) {
        this.formList[7].options = [
          { value: 3, label: '打开URL' },
          { value: 4, label: '无后续动作' }
        ];
      } else {
        if (!val) {
          this.formList[7].options = [];
        } else {
          this.formList[7].options = [
            { value: 1, label: '打开店铺详情' },
            { value: 2, label: '打开商品详情' },
            { value: 3, label: '打开URL' },
            { value: 4, label: '无后续动作' }
          ];
          this.$refs.addEdit.form.setFieldsValue({areas: '0'});
        }

        this.formList[2].disabled = true;
      }
      this.formList[8].isShow = false;
      this.formList[9].isShow = false;
      this.formList[10].isShow = false;
    },
    beforeUpload (file, fileList, item) {
      const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/png' || file.type === 'image/gif';
      if (!isJpgOrPng) {
        this.$message.error('请选择jpg、jpeg、png或者gif格式的图片!');
      }
      return isJpgOrPng;
    },
    shoptagsClose (removedTag) {
      this.$refs.addEdit.form.setFieldsValue({shop: undefined});
      const tags = this.tags ? this.tags.filter(tag => tag !== removedTag) : [];
      this.shoptagsClose = tags;
    },
    producttagsClose (removedTag) {
      this.$refs.addEdit.form.setFieldsValue({goods: undefined});
      const tags = this.tags ? this.tags.filter(tag => tag !== removedTag) : [];
      this.producttags = tags;
    },
    chooseShop () {
      this.CSVisible = true;
    },
    chooseProduct () {
      this.CMVisible = true;
    },
    CMConfirm () {
      let sp = this.$refs.productList.getSelectrow();
      if (sp.length > 1) {
        this.$message.error('有且只能选择一种商品');
        return;
      } else if (sp.length < 1) {
        this.$message.error('请选择一种商品');
        return;
      }
      this.producttags[0] = sp[0].title;
      let id = sp[0].goodsId;
      this.$refs.addEdit.form.setFieldsValue({goods: id});

      this.CMVisible = false;
    },
    CSConfirm () {
      let sp = this.$refs.shoplist.getSelectrow();
      if (sp.length > 1) {
        this.$message.error('有且只能选择一家店铺');
        return;
      } else if (sp.length < 1) {
        this.$message.error('请选择一家店铺');
        return;
      }
      this.shoptags[0] = sp[0].shopName;
      let id = sp[0].shopId;
      this.$refs.addEdit.form.setFieldsValue({shop: id});

      this.CSVisible = false;
    },
    typeChange (row) {
      this.shoptags = [];
      this.producttags = [];
      if (row == 1) {
        this.formList[10].isShow = false;
        this.formList[8].isShow = true;
        this.formList[9].isShow = false;
      } else if (row == 2) {
        this.formList[10].isShow = false;
        this.formList[8].isShow = false;
        this.formList[9].isShow = true;
      } else if (row == 3) {
        this.formList[10].isShow = true;
        this.formList[8].isShow = false;
        this.formList[9].isShow = false;
      } else {
        this.formList[8].isShow = false;
        this.formList[9].isShow = false;
        this.formList[10].isShow = false;
      }
    },
    closeFun () {
      this.formList[0].fileList = [];
      this.formList[2].disabled = false;
      this.formList[10].isShow = false;
      this.formList[8].isShow = false;
      this.formList[9].isShow = false;
      this.visible = false;
    },
    show (id) {
      this.visible = true;

      if (id) {
        this.modalTitle = '编辑';
        let url = `${this.editParam.url}${id}`;
        this.$nextTick(() => {
          this.$refs.addEdit.routeQuery = id;
          this.$refs.addEdit.getDetail(url);
        });
      } else {
        this.modalTitle = '添加';
      }
    },
    ResHandle (res) {
      this.closeFun();
      this.$emit('updateTable', res);
      return res;
    },
    detailResHandle (res) {
      if (res.scopeType == 1) {
        this.formList[7].options = [
          { value: 1, label: '打开店铺详情' },
          { value: 2, label: '打开商品详情' },
          { value: 3, label: '打开URL' },
          { value: 4, label: '无后续动作' }
        ];
      } else if (res.scopeType == 2) {
        this.formList[7].options = [
          { value: 3, label: '打开URL' },
          { value: 4, label: '无后续动作' }
        ];
      } else {
        this.formList[7].options = [
          { value: 1, label: '打开店铺详情' },
          { value: 2, label: '打开商品详情' },
          { value: 3, label: '打开URL' },
          { value: 4, label: '无后续动作' }
        ];

        this.formList[2].disabled = true;
      }

      if (res.type == 1) {
        this.formList[8].isShow = true;
        this.formList[9].isShow = false;
        this.formList[10].isShow = false;
        this.shoptags = [res.targetName];
        this.$nextTick(() => {
          this.$refs.addEdit.form.setFieldsValue({shop: res.targetId});
        });
      } else if (res.type == 2) {
        this.formList[8].isShow = false;
        this.formList[9].isShow = true;
        this.formList[10].isShow = false;
        this.producttags = [res.targetName];
        this.$nextTick(() => {
          this.$refs.addEdit.form.setFieldsValue({goods: res.targetId});
        });
      } else if (res.type == 3) {
        this.formList[8].isShow = false;
        this.formList[9].isShow = false;
        this.formList[10].isShow = true;
      }

      let arr = res.areas.split(',');
      this.newRegionSelectByIds(2, arr, 2);
      res.areas = arr;
      return res;
    },
    reqHandle (param) {
      return param;
    },
    addResHandle (res) {
      return res;
    },
    editResHandle (res) {
      return res;
    },
    addreqHandle (req) {
      if (req.shop) {
        req.targetId = req.shop;
        delete req.shop;
      }
      if (req.goods) {
        req.targetId = req.goods;
        delete req.goods;
      }

      req.areas = Array.isArray(req.areas) && req.areas.join(',') || req.areas;
      req.beginTime = Moment(req.beginTime).valueOf();
      req.endTime = Moment(req.endTime).valueOf();
      if (req.faceId) {
        req.faceId = req.faceId.toString();
      }
      return req;
    }
  }
};
</script>
<style lang="less" scoped>
</style>
